import {DatatableComponent} from '@swimlane/ngx-datatable';
import {MiscellaneousUtils} from './miscellaneous.utils';

export class DataTableUtils {
	/**
	 * Expands the Details of a Row
	 * @param tableObject
	 * @param row
	 */
	public static expandRow(tableObject: DatatableComponent, row): void {
		tableObject.rowDetail.collapseAllRows();
		tableObject.rowDetail.toggleExpandRow(row);
		tableObject.recalculate();
	}

	/**
	 * Collapses the Details of a row.
	 */
	public static collapseRow(tableObject: DatatableComponent): void {
		tableObject.rowDetail.collapseAllRows();
	}

	public static filterDataByProperty(data: Array<any>, originalData: Array<any>, filterValue: string, propertyToFilterBy: string): Array<any> {
		let value = filterValue.toLocaleLowerCase();

		// filter our data
		const temp = originalData.filter((item) => {
			return item[propertyToFilterBy].toLowerCase().indexOf(value) !== -1 || !value;
		});

		// return the filtered rows
		return temp;
	}

	public static filterDataByProperties(data: Array<any>, originalData: Array<any>, filters: Array<any>): Array<any> {
		// let temp = [...originalData];
		let temp = MiscellaneousUtils.cloneArray(originalData);
		for (let filter of filters) {
			if (filter.type === 'string') {
				let value = filter.value.toLocaleLowerCase();
				// filter our data
				temp = temp.filter((item) => {
					return item[filter.property].toLowerCase().indexOf(value) !== -1 || !value;
				});
			} else if (filter.type === 'boolean' && filter.value !== null) {
				// filter our data
				temp = temp.filter((item) => {
					return item[filter.property] === filter.value;
				});
			}
		}
		// return the filtered rows
		return temp;
	}
}